import React, { FC, useState, memo } from "react";
import { Button, Typography, Popover, Modal, Badge } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { Bell, ChevronDown } from "lucide-react";
import { useQueryClient } from "@tanstack/react-query";
import { useGetUserInfo } from "../../hooks/api/user/hooks";
import { IUser } from "@src/types/api/user";
import { checkRightAccess } from "../../lib/utils";

const { Text } = Typography;

interface TopProps {
  collapsed: boolean;
  setCollapsed: (value: boolean) => void;
  showDrawer: () => void;
}

const Top: FC<TopProps> = ({ collapsed, setCollapsed, showDrawer }) => {
  const navigate = useNavigate();



    
  const { data } = useGetUserInfo();

  const admin_profile = data?.data as IUser;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleCollapse = () => setCollapsed(!collapsed);

  const handleLogoutClick = () => {
    setIsModalOpen(true);
  };

  const confirmLogout = () => {
    setIsModalOpen(false);
    window.localStorage.clear();
    window.location.reload();
  };

  const handleProfileClick = () => navigate("/profile");

  const renderIconButton = (isDrawer: boolean) => (
    <Button
      type="text"
      className={`hover:bg-none ${
        isDrawer ? "block lg:hidden" : "hidden lg:block"
      }`}
      onClick={isDrawer ? showDrawer : toggleCollapse}
      icon={<img src="/icon/menu-toggle.svg" alt="" />}
    />
  );

  const popoverContent = (
    <div className="flex flex-col gap-2 w-[120px] sm:w-[150px]">
      {/* <button
        onClick={handleProfileClick}
        className="flex items-center gap-2 px-3 py-1 hover:bg-gray-100 rounded"
      >
        <UserOutlined />
        My Profile
      </button> */}
      <hr />
      <button
        onClick={handleLogoutClick} // ✅ Opens modal instead of logging out directly
        className="flex items-center gap-2 px-3 py-1 hover:bg-gray-100 rounded text-red-500"
      >
        <LogoutOutlined />
        Logout
      </button>
    </div>
  );

  return (
    <>
      <div className="ml-3 md:ml-5 mr-3 sm:mr-0 h-[50px] sm:h-[70px] bg-white px-4 flex items-center justify-between shadow-md rounded-b-3xl">
        <div className="flex items-center gap-4">
          {renderIconButton(false)}
          {renderIconButton(true)}

          <div className="hidden md:block">
            <p className="text-gray-500 text-xl text-primary">
              Hello{" "}
              <span className="font-semibold">
                {admin_profile?.name ?? "Admin"}
              </span>{" "}
              welcome back!
            </p>
          </div>
        </div>

        <div className="flex gap-2 sm:gap-3 items-center mr-8">
          {/* <Popover
            content={popoverContent}
            trigger="click"
            placement="bottomRight"
          > */}
          {/* <div className="flex items-center gap-2 sm:gap-3 cursor-pointer">
            {checkRightAccess("", admin_profile || {}) && (
              <Badge count={notificationList?.data?.length} size="small">
                <Link to="/notification">
                  <button
                    onClick={() => {}}
                    className="flex items-center gap-x-2 text-white/80 bg-primary p-2 h-8 rounded-full"
                  >
                    <Bell className="w-4 h-4" />
                  </button>
                </Link>
              </Badge>
            )} */}
            <div className="flex gap-2 items-center">
              <Text className="text-sm sm:text-base font-medium line-clamp-1">
                {/* {admin_profile?.name || "Admin"} */}
              </Text>
              <button
                onClick={handleLogoutClick} // ✅ Opens modal instead of logging out directly
                className="flex items-center gap-2  py-1 hover:bg-gray-100 rounded text-red-500"
              >
                <LogoutOutlined />
                Logout
              </button>
            </div>
          </div>
          {/* </Popover> */}
        </div>

      {/* ✅ Working Logout Confirmation Modal */}
      <Modal
        title="Logout Confirmation"
        open={isModalOpen}
        onOk={confirmLogout}
        onCancel={() => setIsModalOpen(false)}
        okText="Yes, Logout"
        cancelText="Cancel"
      >
        <p>Are you sure you want to logout?</p>
      </Modal>
    </>
  );
};

export default memo(Top);
